/**
 * Audition Compétition & Compagnie — une seule session par saison.
 * La DATE est réglée par l'école dans la console (Réglages → Saison → « Date de
 * l'audition ») et arrive par `GET /api/reglages` : le formulaire, la page Compétition et
 * « Dates importantes » lisent tous ce fichier, il n'y a donc jamais deux dates
 * différentes sur le site. Les valeurs ci-dessous ne servent que de repli.
 */
export const AUDITION = {
  id: "audition_2026_09_26",
  date_iso: "2026-09-26",
  date_label: "Samedi 26 septembre 2026",
  title: "Audition Compétition & Compagnie",
  groupes: "Team Compétition et Compagnie 1000 ARTS",
  lieu: "Salles 1000 ARTS, Chemin des Dailles 10E, Cugy VD",
  url: "/inscription/audition",
};

const JOURS = ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"];
const MOIS = ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août",
  "septembre", "octobre", "novembre", "décembre"];

const libelle = (iso) => {
  const d = new Date(`${iso}T00:00:00`);
  if (Number.isNaN(d.getTime())) return "";
  const jour = `${JOURS[d.getDay()]} ${d.getDate()} ${MOIS[d.getMonth()]} ${d.getFullYear()}`;
  return jour.charAt(0).toUpperCase() + jour.slice(1);
};

// La date réglée dans la console remplace la date de repli, sur place.
export function appliquerAuditionConsole(dateIso) {
  const iso = String(dateIso || "").slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(iso)) return;
  AUDITION.date_iso = iso;
  AUDITION.date_label = libelle(iso) || AUDITION.date_label;
  AUDITION.id = `audition_${iso.replace(/-/g, "_")}`;
}

// Une fois la date passée, le site n'annonce plus de date et le formulaire se ferme :
// personne ne s'inscrit pour rien. L'école pose la date suivante dans la console.
// Date du jour en heure LOCALE : `toISOString()` donnait la date UTC (la veille entre
// minuit et 2 h en Suisse).
function aujourdhuiLocal(now = new Date()) {
  const m = String(now.getMonth() + 1).padStart(2, "0");
  const j = String(now.getDate()).padStart(2, "0");
  return `${now.getFullYear()}-${m}-${j}`;
}

export function auditionPassee(now = new Date()) {
  const iso = String(AUDITION.date_iso || "").slice(0, 10);
  if (!iso) return true;
  return iso < aujourdhuiLocal(now);
}
